var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77713 7.99995H5.33268V9.5555H3.77713V7.99995ZM14.666 3.33328V14.2222C14.666 15.0855 13.9738 15.7777 13.1105 15.7777H2.22157C1.35824 15.7777 0.666016 15.0777 0.666016 14.2222V3.33328C0.666016 2.47772 1.36602 1.77772 2.22157 1.77772H2.99935V0.222168H4.5549V1.77772H10.7771V0.222168H12.3327V1.77772H13.1105C13.9738 1.77772 14.666 2.47772 14.666 3.33328ZM2.22157 4.88883H13.1105V3.33328H2.22157V4.88883ZM13.1105 14.2222V6.44439H2.22157V14.2222H13.1105ZM9.99935 9.5555V7.99995H11.5549V9.5555H9.99935ZM6.88824 9.5555V7.99995H8.44379V9.5555H6.88824ZM3.77713 11.1111H5.33268V12.6666H3.77713V11.1111ZM9.99935 12.6666V11.1111H11.5549V12.6666H9.99935ZM6.88824 12.6666V11.1111H8.44379V12.6666H6.88824Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDate);
export default __webpack_public_path__ + "static/media/icon_date.9bafd8a3ff6329f372142461aab637e7.svg";
export { ForwardRef as ReactComponent };